<template>
  <PageTemplate>
    <Slides />
    <QuickLinks />
    <Specialties />
    <PagesBanners />
    <PressRoom />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Slides from "./Slides.vue";
import QuickLinks from "./QuickLinks.vue";
import Specialties from "../../templates/Specialties.vue";
import PagesBanners from "./PagesBanners.vue";
import PressRoom from "./PressRoom.vue";

export default {
  components: {
    PageTemplate,
    Slides,
    QuickLinks,
    Specialties,
    PagesBanners,
    PressRoom,
  },
};
</script>
